// import React, { Suspense } from "react";
// import { createRoot } from "react-dom/client";
// import { Provider } from "react-redux";
// import reportWebVitals from "./reportWebVitals";
// import { PersistGate } from "redux-persist/integration/react";
// import { store, persistor } from "./redux/store";
// import { Spin } from "antd";
// import App from "./App";
// import { BrowserRouter, Outlet } from "react-router-dom";

// const contentStyle = {
//   padding: 50,
//   background: "rgba(0, 0, 0, 0.05)",
//   borderRadius: 4,
// };
// const content = <div style={contentStyle} />;

// const Main = () => {
//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         <BrowserRouter>
//           <Suspense
//             fallback={
//               <div
//                 style={{ height: "100vh", width: "100%", alignItems: "center" }}
//                 className="d-flex justify-content-center"
//               >
//                 <Spin size="large" style={{ height: "100%", width: "100%" }}>
//                   {content}
//                 </Spin>
//               </div>
//             }
//           >
//             <App />
//             <Outlet />
//           </Suspense>
//         </BrowserRouter>
//       </PersistGate>
//     </Provider>
//   );
// };

// const root = createRoot(document.getElementById("root"));
// root.render(<Main />);

// reportWebVitals();

import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import { Spin } from "antd";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const contentStyle = {
  padding: 50,
  background: "rgba(0, 0, 0, 0.05)",
  borderRadius: 4,
};
const content = <div style={contentStyle} />;

const Main = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
          }}
        >
          <Suspense
            fallback={
              <div
                style={{ height: "100vh", width: "100%", alignItems: "center" }}
                className="d-flex justify-content-center"
              >
                <Spin size="large" style={{ height: "100%", width: "100%" }}>
                  {content}
                </Spin>
              </div>
            }
          >
            <App />
          </Suspense>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
};

const root = createRoot(document.getElementById("root"));
root.render(<Main />);

reportWebVitals();
